<template>
    <div class="animated fadeIn">
        <basic-heading title="Batch Result Manager"></basic-heading>
        <batch-result-manager-table></batch-result-manager-table>
    </div>
</template>

<script>
import BasicHeading from '@/components/shared/BasicHeading';
import BatchResultManagerTable from '@/components/lab/resultmanager/BatchResultManagerTable';

export default {
    name: "ResultManager",
    components: {
        BasicHeading,
        BatchResultManagerTable
    },
};
</script>